import { Flight, FlightTimeType } from '../../../../../../backend';

export const getTurnaroundArrivalTime = (flight: Flight, type: FlightTimeType) => {
    if (type === FlightTimeType.A) {
        return flight?.aibt;
    } else if (type === FlightTimeType.E) {
        return flight?.eibt;
    } else {
        return null;
    }
};

export const getTurnaroundDepartureTime = (flight: Flight, type: FlightTimeType) => {
    if (type === FlightTimeType.A) {
        return flight?.aobt;
    } else if (type === FlightTimeType.P) {
        return flight?.pobt;
    } else if (type === FlightTimeType.T) {
        return flight?.tobt;
    } else if (type === FlightTimeType.E) {
        return flight?.eobt;
    } else {
        return null;
    }
};

export const arrivalTimeTitle: Record<FlightTimeType, string> = {
    [FlightTimeType.A]: 'ATA',
    [FlightTimeType.E]: 'ETA',
    [FlightTimeType.S]: 'STA',
    [FlightTimeType.T]: null,
    [FlightTimeType.P]: null,
};

export const departureTimeTitle: Record<FlightTimeType, string> = {
    [FlightTimeType.A]: 'ATD',
    [FlightTimeType.P]: 'PTD',
    [FlightTimeType.T]: 'TTD',
    [FlightTimeType.E]: 'ETD',
    [FlightTimeType.S]: 'STD',
};
